export default __webpack_public_path__ + "static/media/icon-timbrado-pago.72cf093a.svg";